import { FilterInput } from "../types";
import { BulkMessageStartTermInput } from "@/__generated__/graphql";
import { SelectOption } from "@/components/FormInputs/types";

export function buildStartTermOptions(
  cohortYear: FilterInput,
  entryTerm: FilterInput,
  currentCohortYear: number | undefined,
): SelectOption[] {
  if (
    entryTerm?.options?.length &&
    cohortYear?.options?.length &&
    currentCohortYear
  ) {
    const entryTerms = entryTerm.options;
    const selectableCohortOptions = cohortYear.options.filter(
      ({ value }) => parseInt(value) >= currentCohortYear - 1,
    );

    const mapStartTerm = (
      cohortYear: SelectOption,
      entryTerm?: SelectOption,
    ) => {
      return {
        label: `${entryTerm?.label} ${cohortYear.label}`,
        value: startTermToString(entryTerm?.value, cohortYear?.value),
      };
    };

    const startTermOptions = selectableCohortOptions
      .map((cohortYear) =>
        entryTerms.map((entryTerm) => mapStartTerm(cohortYear, entryTerm)),
      )
      .flat();

    return startTermOptions;
  }

  return [];
}

export function deconstructStartTerms(
  startTerms?: string[],
): BulkMessageStartTermInput[] {
  return (
    startTerms?.map((startTerm) => {
      const [semester, year] = startTerm.split(".");
      return {
        semester,
        year: Number.parseInt(year),
      } as BulkMessageStartTermInput;
    }) ?? []
  );
}

export function startTermsToOptionValue(
  startTerms: BulkMessageStartTermInput[],
): string[] {
  return startTerms?.map(({ semester, year }) =>
    startTermToString(semester, year),
  );
}

function startTermToString(semester?: string, year?: number | string) {
  return `${semester}.${year}`;
}
